import {
    IonFab,
    IonFabList,
    IonFabButton,
    IonIcon,
    IonSpinner
   } from "@ionic/react";
   import { chevronBackOutline } from "ionicons/icons";
   import {
    PlayCircleOutline,
    PauseCircleOutline,
    FastForwardSharp,
    FastRewindSharp,
    CloudDownloadSharp,
    CloudDoneSharp,
    ArrowForwardIosSharp,
    ArrowBackIosSharp,
    PersonAddAlt1Sharp
   } from "@mui/icons-material";

   import CircularProgress from "@material-ui/core/CircularProgress";

function FabPlayer(props) {

    return(
        <div className={props.controls === "true" || props.isLandscape === true ? null : "phide"} style={{ position: "fixed", right: "18px", bottom: "11px", zIndex: 1000000000 }}>
        <p style={{ visibility: "hidden" }}>button</p>
        <IonFab activated={props.fabClose ? false : true} className="noselect" vertical="center" horizontal="center">
         <CircularProgress
          value={props.duration ? (props.cposition / (props.durFlag - 1)) * 100 : (props.current / props.dur) * 100}
          aria-labelledby="continuous-slider"
          size={68}
          style={{ position: "absolute", top: "-6px", right: "-6px", opacity: "50%" }}
          variant="determinate"
         />
         <IonFabButton
          onClick={() => {
           props.setFabClose(!props.fabClose);
          }}
          color={props.colorh}
          style={{ opacity: "50%" }}
         >
          <IonIcon icon={chevronBackOutline} />
         </IonFabButton>
         <IonFabList side="start">
          <IonFabButton color={props.colorh} onClick={props.download}>
           {props.isDownloaded ? <CloudDoneSharp style={{ fontSize: 18 }} /> :  props.isDownloading ? <IonSpinner style={{ width:"18px", height:"18px" }} name="crescent"></IonSpinner> : <CloudDownloadSharp style={{ fontSize: 18 }} />}
          </IonFabButton>
    
           
          <IonFabButton
          color={props.colorh}
          onClick={() => {
           props.seekRight()
          }}
         >
          {props.bplay.fold ? <ArrowForwardIosSharp style={{ fontSize: 18 }} /> : <FastForwardSharp style={{ fontSize: 18 }} />}
         </IonFabButton>
          <IonFabButton color={props.colorh} onClick={()=>{
                if (props.duration){
                    props.playoff()
                }else{
                    props.playon()
                } 
              }}>
           {props.ppb ? <PauseCircleOutline style={{ fontSize: 18 }} /> : <PlayCircleOutline style={{ fontSize: 18 }} />}
          </IonFabButton>
          <IonFabButton
           color={props.colorh}
           onClick={() => {
            props.seekLeft()
           }}
          >
           {props.bplay.fold ?  <ArrowBackIosSharp style={{ fontSize: 18 }} /> : <FastRewindSharp style={{ fontSize: 18 }} />}
          </IonFabButton>
          <IonFabButton color={props.colorh} onClick={() => props.setShowActionSheet(true)}>
           <PersonAddAlt1Sharp style={{ fontSize: 18 }} />
          </IonFabButton>
         </IonFabList>
        </IonFab> 
       </div>
    );

} 

export default FabPlayer